import PaymentsPaypalButtonComponent from './payments-paypal-button.component'

const PaymentsPaypalButtonModule = angular.module('cdbl.payments-paypal-button', [

])
  .component('cdblPaymentsPaypalButton', PaymentsPaypalButtonComponent)
  .name

export default PaymentsPaypalButtonModule
